import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { CB } from '../../../../constants/paymentMethods';

import CardsPicto from './CardsPicto';

import { CreditCardContainer } from './CreditCardStyle';

const CreditCard = ({ selectedMethod, handleMethodChange, i18n }) => {
    return (
        <CreditCardContainer onClick={() => handleMethodChange(CB)}>
            <div>
                <input type="radio" id="cb" name="cb" value={CB} checked={selectedMethod === CB} />

                <label htmlFor="cb">{i18n.PAYMENT_CHOICE.CB}</label>
            </div>
            <CardsPicto />
        </CreditCardContainer>
    );
};

CreditCard.propTypes = {
    selectedMethod: PropTypes.string,
    handleMethodChange: PropTypes.func
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.EBON
    };
};

export default connect(mapStateToProps)(CreditCard);



// WEBPACK FOOTER //
// ./src/components/funnel/payment-selection-step/payment-choice/CreditCard.js